define('presentation/signup/presentationObjects/hubSpotContactPresentationObject',[],function() {
    return function(){
        const self = this;

        self.firstName = ko.observable("");
        self.lastName = ko.observable("");
        self.email = ko.observable("-");
        self.additionalEmails = ko.observableArray([]);
        self.phone = ko.observable("-");
    };
});

